import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";

export default function RouteChangeLoader({
  children,
  delayMs = 200,   // показувати тільки якщо довше 200мс
  minShowMs = 180 // якщо вже показали — потримати мінімум трохи
}) {
  const location = useLocation();

  const [visible, setVisible] = useState(false);

  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);
  const lastShownAtRef = useRef(0);

  useEffect(() => {
    // очистка старих таймерів
    if (showTimerRef.current) clearTimeout(showTimerRef.current);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);

    // 1) плануємо показ через delayMs
    showTimerRef.current = setTimeout(() => {
      lastShownAtRef.current = Date.now();
      setVisible(true);
    }, delayMs);

    // 2) "завершення навігації"
    // У звичайному Router ми не знаємо реального end,
    // тому робимо м'яке завершення дуже скоро.
    // Лоадер з’явиться тільки якщо цей момент "перекриється" delayMs.
    const finishSoonMs = 0; // можна лишити 0

    hideTimerRef.current = setTimeout(() => {
      // якщо лоадер ще не встиг показатися — просто не показуємо
      if (!visible) {
        if (showTimerRef.current) clearTimeout(showTimerRef.current);
        showTimerRef.current = null;
        return;
      }

      // якщо вже показали — поважаємо minShowMs
      const elapsed = Date.now() - lastShownAtRef.current;
      const remaining = Math.max(0, minShowMs - elapsed);

      hideTimerRef.current = setTimeout(() => {
        setVisible(false);
      }, remaining);
    }, finishSoonMs);

    return () => {
      if (showTimerRef.current) clearTimeout(showTimerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
    // важливо слухати повну зміну локації
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <GlobalLoader show={visible} />
      {children}
    </>
  );
}
